export default __webpack_public_path__ + "static/media/moon_reflection.becd1ce2.svg";